import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    ModuleProps,
    LoadModuleById,
    setModuleEdit,
    setModuleReloadEdit,
    initModule,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    moduleId = null,
}: ModuleProps) => {
    const module = useSelector((state: StoreType) => state.module.moduleEdit)
    const reloadEdit = useSelector((state: StoreType) => state.module.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setModuleReloadEdit(false))
        setTimeout(() => {
            dispatch(setModuleReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (moduleId === 0) {
            dispatch(setModuleEdit(initModule))
            reload()
        } else {
            setLoadState(PENDING)
            LoadModuleById(moduleId).then((res) => {
                dispatch(setModuleEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!module) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {module.id ? `${lang.editModule} # ${module.id}` : lang.addModule}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form module={module} />
                }
                {
                    reloadEdit
                    && <Form module={module} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
